const DEFAULT_PATH = "/leads"

/**
 * Where a magic login lands. Only same-site paths are honoured ("/x", never
 * "//host" or "https://…"), so a crafted link can't bounce the freshly
 * logged-in customer to another site.
 */
export function safeNextPath(next) {
  if (typeof next !== "string" || !next.startsWith("/")) return DEFAULT_PATH
  if (next.startsWith("//") || next.startsWith("/\\")) return DEFAULT_PATH
  return next
}
